module.exports = __webpack_public_path__ + "img/bot_sqjqr.eed118ee.png";